import mod from "-!./Properties.js?vue&type=script&lang=js&external"; export default mod; export * from "-!./Properties.js?vue&type=script&lang=js&external"